module.exports = __webpack_public_path__ + "img/05_get_more.05d286f3.svg";